import { NavLink, useNavigate } from 'react-router-dom';
import API_URL from '../apiConfig';
import logo from "../assets/images/logo.png";


 function NavbarDash() {

  const navigate = useNavigate();

    const handleLogout = () => {
      fetch(`${API_URL}/admin/logout`, {
        method: "POST",
        credentials: "include"
      })
      .finally(() => {
        navigate("/connexion-admin");
      });
    };


  return (
    <div className="bg-lamp text-white shadow-lg d-flex flex-column" style={{ width: 'var(--sidebar-w)', position: 'fixed', left: 0, top: 0, bottom: 0, zIndex: 1000 }}>
      {/* Sidebar Header */}
      <div className="p-4 border-bottom border-white border-opacity-10 d-flex align-items-center gap-2">
        <div className="flex-shrink-0">
          <img src={logo} alt="Logo" width="45" className="rounded-circle border border-2 border-white shadow-sm"/>
        </div>
        <div className="overflow-hidden">
          <h4 className="h6 mb-0 fw-bold outfit text-truncate">LAMP Edification</h4>
          <span className="text-white text-opacity-50 small d-block text-truncate" style={{ fontSize: '0.65rem' }}>DASHBOARD ADMIN</span>
        </div>
      </div>

      {/* Menu Links - Scrollable */}
      <nav className="flex-grow-1 px-2 py-2 overflow-y-auto custom-scrollbar">
        <ul className="nav flex-column gap-1">
          <li className="nav-item">
            <NavLink to="." end className={({isActive}) => `nav-link d-flex align-items-center gap-3 p-3 rounded-3 transition ${isActive ? 'bg-white bg-opacity-20 fw-bold active' : 'text-white text-opacity-75 hover-bg-opacity'}`}>
              <i className="bi bi-grid-fill"></i> Accueil
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="meditations" className={({isActive}) => `nav-link d-flex align-items-center gap-3 p-3 rounded-3 transition ${isActive ? 'bg-white bg-opacity-20 fw-bold active' : 'text-white text-opacity-75 hover-bg-opacity'}`}>
              <i className="bi bi-journals"></i> Méditations
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="gestion" className={({isActive}) => `nav-link d-flex align-items-center gap-3 p-3 rounded-3 transition ${isActive ? 'bg-white bg-opacity-20 fw-bold active' : 'text-white text-opacity-75 hover-bg-opacity'}`}>
              <i className="bi bi-kanban"></i> Gestion
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="publier" className={({isActive}) => `nav-link d-flex align-items-center gap-3 p-3 rounded-3 transition ${isActive ? 'bg-white bg-opacity-20 fw-bold active' : 'text-white text-opacity-75 hover-bg-opacity'}`}>
              <i className="bi bi-check-circle-fill"></i> Méd. Publiées
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="partenaires" className={({isActive}) => `nav-link d-flex align-items-center gap-3 p-3 rounded-3 transition ${isActive ? 'bg-white bg-opacity-20 fw-bold active' : 'text-white text-opacity-75 hover-bg-opacity'}`}>
              <i className="bi bi-people-fill"></i> Partenaires
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="temoignages" className={({isActive}) => `nav-link d-flex align-items-center gap-3 p-3 rounded-3 transition ${isActive ? 'bg-white bg-opacity-20 fw-bold active' : 'text-white text-opacity-75 hover-bg-opacity'}`}>
              <i className="bi bi-star-fill"></i> Témoignages
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="messages" className={({isActive}) => `nav-link d-flex align-items-center gap-3 p-3 rounded-3 transition ${isActive ? 'bg-white bg-opacity-20 fw-bold active' : 'text-white text-opacity-75 hover-bg-opacity'}`}>
              <i className="bi bi-chat-left-text-fill"></i> Messages
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="parametres" className={({isActive}) => `nav-link d-flex align-items-center gap-3 p-3 rounded-3 transition ${isActive ? 'bg-white bg-opacity-20 fw-bold active' : 'text-white text-opacity-75 hover-bg-opacity'}`}>
              <i className="bi bi-gear-fill"></i> Paramètres
            </NavLink>
          </li>
        </ul>
      </nav>

      {/* Logout Button - Fixé en bas */}
      <div className="p-3 border-top border-white border-opacity-10 bg-lamp mt-auto">
        <button 
          onClick={handleLogout} 
          className="btn w-100 d-flex align-items-center justify-content-center gap-2 p-3 rounded-3 bg-white bg-opacity-10 text-white hover-bg-danger transition-all border-0 shadow-sm"
          style={{ cursor: 'pointer' }}
        >
          <i className="bi bi-box-arrow-left fs-5"></i>
          <span className="fw-bold px-1">DÉCONNEXION</span>
        </button>
      </div>
    </div>
  );
}

export default NavbarDash;